export interface PersonTypeInfo {
  codigo: string;
  descripcion: string;
  valor: number;
}

export const PERSON_TYPE = {
  FISICA: {
    codigo: 'F',
    descripcion: 'Persona Física',
    valor: 98,
  } as PersonTypeInfo,
  JURIDICA: {
    codigo: 'J',
    descripcion: 'Persona Jurídica',
    valor: 99,
  } as PersonTypeInfo,
};

export const getPersonTypeByCode = (code: string): PersonTypeInfo | undefined => {
  return Object.values(PERSON_TYPE).find((type) => type.codigo === code);
};
